import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuthLoginMutation } from '../../lib/api/authAPI';
import { setAccessToken, setadminInfo } from '../../lib/slices/authSlice';
import { useDispatch } from 'react-redux';

export const AdminLogIn = () => {
    const navigate = useNavigate();
    const [authLoginMutation, { loading }] = useAuthLoginMutation();
    const [form, setForm] = useState({}) // This is the form state
    const [errorState, setErrorState] = useState() // This is the error state
    const dispatch = useDispatch(); // This is the dispatch function

    const handleChange = (e) => {
        // This function handles the form input change
        setForm({ ...form, [e.target.name]: e.target.value })
    }



    // This function handles the form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // This is the login mutation
        try {
            setErrorState("")
            const { userId, password } = form;
            console.log(process.env.REACT_APP_BASE_URL)
            const { data, error } = await authLoginMutation({ userId, password });
            if (data?.accessToken) {
                dispatch(setAccessToken(data.accessToken))
                dispatch(setadminInfo(data.adminInfo))
                navigate('/admin')
            }
            if (error) {
                if (error?.status === 429) {
                    setErrorState("Too many requests. Please try again later")
                }
                if (error?.status === 400) {
                    setErrorState("Missing credentials. Please try again.");
                }
                else
                    setErrorState(error?.data?.error + ". Please try again.")
            }
        } catch (error) {
            setErrorState(error.message)
        }
    }
    return (
        // This is the login form
        <form onSubmit={(e) => handleSubmit(e)} className='w-full flex flex-col gap-10 items-center justify-center'>

            {/* // This is the login form Title */}
            <div className='w-fit flex flex-col justify-center items-center gap-2 font-semibold text-white text-2xl'>
                <h1 className=' text-2xl'>
                    Log-in
                </h1>
                <hr className='w-[30%]' />
            </div>

            {/* // This is the error message */}
            <div>
                {errorState && (
                    <p className='text-red-500 text-center'>{errorState}</p>
                )}
            </div>

            {/* Username */}
            <div className="username flex flex-col w-[65%] ">
                <label htmlFor="username" className='text-white'>Username</label>
                <input type="text" placeholder='Username' name='userId' className='p-[10px] bg-white text-black w-full' onChange={handleChange} minLength={3} />
            </div>

            {/* Password */}
            <div className="password flex flex-col w-[65%]">
                <label htmlFor="password" className='text-white'>Password</label>
                <input type="password" placeholder='Password' name="password" className='p-[10px] bg-white text-black w-full' onChange={handleChange} />
                <Link href="/admin/forget-password" className='text-white'>Forgot Password?</Link>
            </div>

            {/* Submit Button */}
            <button className='py-[7px] px-[30px] font-bold rounded-lg disabled:bg-slate-400 bg-white text-black' type='submit' disabled={loading}>Log-in</button>
        </form>
    )
}
